'use client';

import { usePathname } from 'next/navigation';

import Navbar from "@/components/frontend/common/Navbar";
import Footer from "@/components/frontend/common/Footer";
import MaintenancePage from "@/components/frontend/MaintenancePage";

export default function ConditionalLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const IS_SHUTDOWN = true;

  if (IS_SHUTDOWN) {
    return <MaintenancePage />;
  }
  
  // Check if current path is under /ad or /dashboard or /admin or /checkout
  const isAdPage = pathname.startsWith('/ad');
  const isDashboardPage = pathname.startsWith('/dashboard');
  const isAdminPage = pathname.startsWith('/admin');
  const isCheckoutPage = pathname.startsWith('/checkout');
  const isHireCheckoutPage = pathname.startsWith('/hire-checkout');
  
  if (isAdPage || isDashboardPage || isAdminPage) {
    // For ad, dashboard, and admin pages, don't show main navbar/footer
    return <>{children}</>;
  }

  if (isCheckoutPage || isHireCheckoutPage) {
    // For checkout pages, show navbar but no footer - provides branding/trust while keeping focused
    return (
      <>
        <Navbar />
        {children}
      </>
    );
  }
  
  // For all other pages, show normal layout
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}
